"use client";

import { lazy, Suspense, useEffect, useState } from "react";

const NanoNetworkBackground = lazy(() =>
  import("@/components/nano-background/NanoNetworkBackground").then((module) => ({
    default: module.NanoNetworkBackground,
  })),
);

type IdleWindow = Window & {
  requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
  cancelIdleCallback?: (id: number) => void;
};

/**
 * A rede animada é decorativa e não deve disputar o caminho crítico. Em
 * telas pequenas ela permanece desligada; no desktop entra apenas quando o
 * navegador estiver ocioso, depois que o conteúdo principal já pintou.
 */
export function DeferredNanoNetworkBackground() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const mobile = window.matchMedia("(max-width: 767px)").matches;
    const saveData = Boolean(
      (navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData,
    );
    if (mobile || saveData) return;

    const idleWindow = window as IdleWindow;
    if (idleWindow.requestIdleCallback) {
      const id = idleWindow.requestIdleCallback(() => setEnabled(true), { timeout: 3000 });
      return () => idleWindow.cancelIdleCallback?.(id);
    }

    const id = window.setTimeout(() => setEnabled(true), 1800);
    return () => window.clearTimeout(id);
  }, []);

  if (!enabled) return null;

  return (
    <Suspense fallback={null}>
      <NanoNetworkBackground />
    </Suspense>
  );
}
